import NetworkApi from "../../data/network/NetworkApi";
import NetworkApiImpl from "../../data/network/NetworkApiImpl";
import { AnswerRepository } from "../../data/repository/answer/AnswerRepository";
import { AnswerRepositoryImpl } from "../../data/repository/answer/AnswerRepositoryImpl";
import { AuthRepository } from "../../data/repository/auth/AuthRepository";
import { AuthRepositoryImpl } from "../../data/repository/auth/AuthRepositoryImpl";
import { CategoryRepository } from "../../data/repository/category/CategoryRepository";
import { CategoryRepositoryImpl } from "../../data/repository/category/CategoryRepositoryImpl";
import { GameRepository } from "../../data/repository/game/GameRepository";
import { GameRepositoryImpl } from "../../data/repository/game/GameRepositoryImpl";
import { PlayerRepository } from "../../data/repository/player/PlayerRepository";
import { PlayerRepositoryImpl } from "../../data/repository/player/PlayerRepositoryImpl";
import { QuestionRepository } from "../../data/repository/question/QuestionRepository";
import { QuestionRepositoryImpl } from "../../data/repository/question/QuestionRepositoryImpl";
import { UploadFileRepository } from "../../data/repository/uploadFIle/UploadFileRepository";
import { UploadFileRepositoryImpl } from "../../data/repository/uploadFIle/UploadFileRepositoryImpl";
import {
  GetAnswerUseCase,
  GetAnswerUseCaseImpl,
} from "../../domain/usecase/answer/get/GetUseCase";

import {
  GetAnswerByQuestionIdUseCase,
  GetAnswerByQuestionIdUseCaseImpl,
} from "../../domain/usecase/answer/getByQuestionId/GetByQuestionIdUseCase";
import {
  LoginAnonymouslyUseCase,
  LoginAnonymouslyUseCaseImpl,
} from "../../domain/usecase/auth/LoginAnonymously/UseCase";

import {
  GetAllCategoriesUseCase,
  GetAllCategoriesUseCaseImpl,
} from "../../domain/usecase/category/getAll/GetAllUseCase";
import {
  CreateGameUseCase,
  CreateGameUseCaseImpl,
} from "../../domain/usecase/game/create/UseCase";
import {
  GameGiveRatingUseCase,
  GameGiveRatingUseCaseImpl,
} from "../../domain/usecase/game/giveRating/GiveRatingUseCase";
import {
  UpdateGameUseCase,
  UpdateGameUseCaseImpl,
} from "../../domain/usecase/game/update/UseCase";
import {
  PlayerGetCurrentInfoUseCase,
  PlayerGetCurrentInfoUseCaseImpl,
} from "../../domain/usecase/player/GetCurrentInfo/GetCurrentInfoUseCase";
import {
  GetRandomQuestionUseCase,
  GetRandomQuestionUseCaseImpl,
} from "../../domain/usecase/question/getRandomQuestion/GetRandomQuestionUseCase";
import {
  QuestionGiveAnswerUseCase,
  QuestionGiveAnswerUseCaseImpl,
} from "../../domain/usecase/question/giveAnswer/QuestionGiveAnswerUseCase";
import {
  UploadFileUseCase,
  UploadFileUseCaseImpl,
} from "../../domain/usecase/uploadFile/UploadFileUseCase";
import { provideApiBuilder } from "./NetworkModule";

function provideNetworkApi(): NetworkApi {
  return new NetworkApiImpl(provideApiBuilder());
}

// auth
function provideAuthRepository(): AuthRepository {
  return new AuthRepositoryImpl(provideNetworkApi());
}
export function provideLoginAnonymouslyUseCase(): LoginAnonymouslyUseCase {
  return new LoginAnonymouslyUseCaseImpl(provideAuthRepository());
}

// upload file
function provideUploadImageRepository(): UploadFileRepository {
  return new UploadFileRepositoryImpl(provideNetworkApi());
}
export function provideUploadFileUseCase(): UploadFileUseCase {
  return new UploadFileUseCaseImpl(provideUploadImageRepository());
}

// player
function providePlayerRepository(): PlayerRepository {
  return new PlayerRepositoryImpl(provideNetworkApi());
}
export function providePlayerGetCurrentInfoUseCase(): PlayerGetCurrentInfoUseCase {
  return new PlayerGetCurrentInfoUseCaseImpl(providePlayerRepository());
}

// category
function provideCategoryRepository(): CategoryRepository {
  return new CategoryRepositoryImpl(provideNetworkApi());
}
export function provideGetAllCategoriesUseCase(): GetAllCategoriesUseCase {
  return new GetAllCategoriesUseCaseImpl(provideCategoryRepository());
}

// question
function provideQuestionRepository(): QuestionRepository {
  return new QuestionRepositoryImpl(provideNetworkApi());
}
export function provideGetRandomQuestionUseCase(): GetRandomQuestionUseCase {
  return new GetRandomQuestionUseCaseImpl(provideQuestionRepository());
}
export function provideQuestionGiveAnswerUseCase(): QuestionGiveAnswerUseCase {
  return new QuestionGiveAnswerUseCaseImpl(provideQuestionRepository());
}

// answer
function provideAnswerRepository(): AnswerRepository {
  return new AnswerRepositoryImpl(provideNetworkApi());
}
export function provideGetAnswerByQuestionIdUseCase(): GetAnswerByQuestionIdUseCase {
  return new GetAnswerByQuestionIdUseCaseImpl(provideAnswerRepository());
}
export function provideGetAnswerUseCase(): GetAnswerUseCase {
  return new GetAnswerUseCaseImpl(provideAnswerRepository());
}

// game
function provideGameRepository(): GameRepository {
  return new GameRepositoryImpl(provideNetworkApi());
}
export function provideCreateGameUseCase(): CreateGameUseCase {
  return new CreateGameUseCaseImpl(provideGameRepository());
}
export function provideUpdateGameUseCase(): UpdateGameUseCase {
  return new UpdateGameUseCaseImpl(provideGameRepository());
}
export function provideGameGiveRatingUseCase(): GameGiveRatingUseCase {
  return new GameGiveRatingUseCaseImpl(provideGameRepository());
}
